export const RESET_ADHOC2FA = 'RESET_ADHOC2FA';

export const SET_ADHOC2FA_PREP_REQUESTED = 'SET_ADHOC2FA_PREP_REQUESTED';
export const SET_ADHOC2FA_PREP_COMPLETED = 'SET_ADHOC2FA_PREP_COMPLETED';
export const SET_ADHOC2FA_PREP_FAILED = 'SET_ADHOC2FA_PREP_FAILED';

export const SET_ADHOC2FA_SEND_REQUESTED = 'SET_ADHOC2FA_SEND_REQUESTED';
export const SET_ADHOC2FA_SEND_COMPLETED = 'SET_ADHOC2FA_SEND_COMPLETED';
export const SET_ADHOC2FA_SEND_FAILED = 'SET_ADHOC2FA_SEND_FAILED';

export const SET_ADHOC2FA_CONFIRM_REQUESTED = 'SET_ADHOC2FA_CONFIRM_REQUESTED';
export const SET_ADHOC2FA_CONFIRM_COMPLETED = 'SET_ADHOC2FA_CONFIRM_COMPLETED';
export const SET_ADHOC2FA_CONFIRM_FAILED = 'SET_ADHOC2FA_CONFIRM_FAILED';

export const SET_ADHOC2FA_STATUS_REQUESTED = 'SET_ADHOC2FA_STATUS_REQUESTED';
export const SET_ADHOC2FA_STATUS_ABORTED = 'SET_ADHOC2FA_STATUS_ABORTED';
export const SET_ADHOC2FA_STATUS_COMPLETED = 'SET_ADHOC2FA_STATUS_COMPLETED';
export const SET_ADHOC2FA_STATUS_FAILED = 'SET_ADHOC2FA_STATUS_FAILED';
